
$(function(){    
    $(".stricky-header .main-menu__list li").mouseenter(function(e){
        // 显示2级菜单
        $(this).addClass("menu_display")
    }).mouseleave(function() {
        // 隐藏2级菜单
        $(this).removeClass('menu_display') 
    })
    
    
    $(".main-menu__list li").mouseenter(function(e){
        // 显示2级菜单
        $(this).addClass("menu_display")
    }).mouseleave(function() {
        // 隐藏2级菜单
        $(this).removeClass('menu_display') 
    })
    
    $(".he_solutuli").mouseenter(function(e){
        // 2级菜单图标显隐
        $('.nav_active').removeClass('nav_active');  
        $(this).addClass("nav_active");
        // 展示3级菜单
        $('.active').removeClass('active'); 
        var param = 'two_right_item_' + $(this).data('num')
        $('.'+param).addClass('active'); 
     
    }).mouseleave(function() {
    })
});